"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _default = function _default(_ref) {
  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      objectType = _ref.objectType;
  var namespaceStr = namespace && namespace.length ? namespace + "/" : "";
  return "" + namespaceStr + _ActionTypes.default.STAGE_FOR_EDIT + "/" + objectType;
};

exports.default = _default;
module.exports = exports.default;